module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "formEvent",
    attrs: {
      "model": _vm.event,
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "Evento Pai"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Selecione um evento",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "change": _vm.changeEvent
    },
    model: {
      value: (_vm.event.event_id),
      callback: function($$v) {
        _vm.$set(_vm.event, "event_id", $$v)
      },
      expression: "event.event_id"
    }
  }, _vm._l((_vm.dependencies.events), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.title.$error
    },
    attrs: {
      "label": "Título"
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        _vm.$v.event.title.$touch()
      }
    },
    model: {
      value: (_vm.event.title),
      callback: function($$v) {
        _vm.$set(_vm.event, "title", $$v)
      },
      expression: "event.title"
    }
  }), _vm._v(" "), (!_vm.$v.event.title.required && _vm.$v.event.title.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.type_id.$error
    },
    attrs: {
      "label": "Tipo de Evento"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Selecione o tipo de evento",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.type_id.$touch()
      }
    },
    model: {
      value: (_vm.event.type_id),
      callback: function($$v) {
        _vm.$set(_vm.event, "type_id", $$v)
      },
      expression: "event.type_id"
    }
  }, [_vm._l((_vm.dependencies.event_types), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.description,
        "value": item.id
      }
    })
  }), _vm._v(" "), (_vm.$v.event.type_id.$error) ? _c('validation-message') : _vm._e()], 2), _vm._v(" "), (_vm.$v.event.type_id.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n              Esse campo é obrigatório\n          ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.place_id.$error
    },
    attrs: {
      "label": "Local"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Selecione um local",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.place_id.$touch()
      }
    },
    model: {
      value: (_vm.event.place_id),
      callback: function($$v) {
        _vm.$set(_vm.event, "place_id", $$v)
      },
      expression: "event.place_id"
    }
  }, [_vm._l((_vm.dependencies.places), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.description,
        "value": item.id
      }
    })
  }), _vm._v(" "), (_vm.$v.event.place_id.$error) ? _c('validation-message') : _vm._e()], 2), _vm._v(" "), (_vm.$v.event.place_id.$error) ? _c('div', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n                  Esse campo é obrigatório\n              ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.start_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Início Evento"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Início"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.start_datetime.$touch()
      }
    },
    model: {
      value: (_vm.event.start_datetime),
      callback: function($$v) {
        _vm.$set(_vm.event, "start_datetime", $$v)
      },
      expression: "event.start_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.event.start_datetime.required && _vm.$v.event.start_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.end_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Término Evento"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Término"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.end_datetime.$touch()
      }
    },
    model: {
      value: (_vm.event.end_datetime),
      callback: function($$v) {
        _vm.$set(_vm.event, "end_datetime", $$v)
      },
      expression: "event.end_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.event.end_datetime.required && _vm.$v.event.end_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.start_registration_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Início Inscrições"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Início Inscrições"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.start_registration_datetime.$touch()
      }
    },
    model: {
      value: (_vm.event.start_registration_datetime),
      callback: function($$v) {
        _vm.$set(_vm.event, "start_registration_datetime", $$v)
      },
      expression: "event.start_registration_datetime"
    }
  }), _vm._v(" "), (!_vm.$v.event.start_registration_datetime.required && _vm.$v.event.start_registration_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.end_registration_datetime.$error
    },
    attrs: {
      "label": "Data/Hora Término Inscrições"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "placeholder": "Data/Hora Término Inscrições"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.end_registration_datetime.$touch()
      }
    },
    model: {
      value: (_vm.event.end_registration_datetime),
      callback: function($$v) {
        _vm.$set(_vm.event, "end_registration_datetime", $$v)
      },
      expression: "event.end_registration_datetime"
    }
  }), _vm._v(" "), (!_vm.isSubEvent && !_vm.$v.event.end_registration_datetime.required && _vm.$v.event.end_registration_datetime.$dirty) ? _c('validation-message') : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(!_vm.isSubEvent) ? _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.contact_email.$error && !_vm.isSubEvent
    },
    attrs: {
      "label": "Email de Contato"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.contact_email.$touch()
      }
    },
    model: {
      value: (_vm.event.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.event, "contact_email", $$v)
      },
      expression: "event.contact_email"
    }
  }), _vm._v(" "), (!_vm.$v.event.contact_email.email) ? _c('validation-message', {
    attrs: {
      "message": "O e-mail precisa ser válido."
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Material aos participantes?"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "SIM",
      "inactive-text": "NÃO"
    },
    model: {
      value: (_vm.event.has_material),
      callback: function($$v) {
        _vm.$set(_vm.event, "has_material", $$v)
      },
      expression: "event.has_material"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(!_vm.isSubEvent) ? _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Nº máximo de submissões por autor"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 100
    },
    model: {
      value: (_vm.event.max_submissions_per_author),
      callback: function($$v) {
        _vm.$set(_vm.event, "max_submissions_per_author", $$v)
      },
      expression: "event.max_submissions_per_author"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.isSubEvent) ? _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.vacancies.$error
    },
    attrs: {
      "label": "Nº máximo de vagas"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 20000
    },
    model: {
      value: (_vm.event.vacancies),
      callback: function($$v) {
        _vm.$set(_vm.event, "vacancies", $$v)
      },
      expression: "event.vacancies"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$v.event.vacancies.$error) ? _c('validation-message') : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Carga Horária"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "step": 1,
      "max": 1000
    },
    model: {
      value: (_vm.event.workload),
      callback: function($$v) {
        _vm.$set(_vm.event, "workload", $$v)
      },
      expression: "event.workload"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.website.$error
    },
    attrs: {
      "label": !_vm.isSubEvent ? 'Site do Evento' : 'Link do Regulamento'
    }
  }, [_c('el-input', {
    attrs: {
      "type": "url"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.website.$touch()
      }
    },
    model: {
      value: (_vm.event.website),
      callback: function($$v) {
        _vm.$set(_vm.event, "website", $$v)
      },
      expression: "event.website"
    }
  }), _vm._v(" "), (!_vm.$v.event.website.url) ? _c('validation-message', {
    attrs: {
      "message": "O link precisa ser válido."
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Layout do Certificado do Participante"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Selecione um Layout",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.event.layout_id),
      callback: function($$v) {
        _vm.$set(_vm.event, "layout_id", $$v)
      },
      expression: "event.layout_id"
    }
  }, _vm._l((_vm.dependencies.layouts), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), (_vm.isSubEvent) ? _c('el-form-item', {
    staticClass: "is-required",
    class: {
      'el-form-item--error': _vm.$v.event.coordinators.$error
    },
    attrs: {
      "label": "Coordenadores"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "Selecione os coordenadores",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "input": function($event) {
        _vm.$v.event.coordinators.$touch()
      }
    },
    model: {
      value: (_vm.event.coordinators),
      callback: function($$v) {
        _vm.$set(_vm.event, "coordinators", $$v)
      },
      expression: "event.coordinators"
    }
  }, _vm._l((_vm.dependencies.users), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.pessoa.nome + ' (' + item.ref_pessoa + ')',
        "value": item.id
      }
    })
  })), _vm._v(" "), (_vm.$v.event.coordinators.$error) ? _c('validation-message') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isSubEvent) ? _c('el-form-item', {
    attrs: {
      "label": "Comissão de Apoio"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "filterable": "",
      "multiple": "",
      "clearable": "",
      "placeholder": "Selecione os membros da comissão",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.event.support_committee),
      callback: function($$v) {
        _vm.$set(_vm.event, "support_committee", $$v)
      },
      expression: "event.support_committee"
    }
  }, _vm._l((_vm.dependencies.users), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.pessoa.nome + ' (' + item.ref_pessoa + ')',
        "value": item.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('form-tinymce', {
    attrs: {
      "id": "editorContent",
      "configs": {
        height: 300
      }
    },
    model: {
      value: (_vm.event.description),
      callback: function($$v) {
        _vm.$set(_vm.event, "description", $$v)
      },
      expression: "event.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isSubmitted || _vm.$v.event.$invalid
    },
    on: {
      "click": _vm.onSaveBasicData
    }
  }, [_vm._v("\n            Salvar Alterações\n        ")]), _vm._v(" "), _c('form-cancel-button', {
    attrs: {
      "route-name": "event.index"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49f42a44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/form/BasicData.vue
// module id = 748
// module chunks = 2